export const translations = {
  fr: {
    nav: {
      processus: "Processus",
      services: "Services",
      testimonials: "Témoignages",
      contact: "Contact",
      getStarted: "Commencer",
    },
    hero: {
      eyebrow: "Casablanca · Montréal",
      headlineGold: "Maro",
      headlineCream: "canada",
      tagline: "Votre chemin. Notre expertise.",
      cta: "Commencer mon dossier",
      scroll: "Faites défiler",
    },
    trust: {
      a: "500+ clients accompagnés",
      b: "Conseillers agréés",
      c: "Maroc × Canada",
    },
    opportunity: {
      eyebrow: "L'opportunité",
      headlineBig:
        "Les francophones marocains se qualifient à l'Entrée Express Francophone du Canada avec un seuil CRS significativement plus bas.",
      body: "Le Canada accélère la sélection des candidats francophones hors Québec. Cette politique change la vie de milliers de profils marocains chaque année — médecins, ingénieurs, étudiants, familles. Le moment, c'est maintenant.",
      stat1: "+25%",
      stat1Label: "de candidats francophones admis en 2025",
      stat2: "−85",
      stat2Label: "points CRS sous le seuil général",
    },
    services: {
      eyebrow: "Nos services",
      headline: "Six voies vers le Canada.",
      cta: "En savoir plus",
      list: [
        {
          name: "Entrée Express Francophone",
          desc: "Idéale pour les Marocains francophones. Seuil CRS abaissé grâce aux tirages dédiés aux candidats français.",
        },
        {
          name: "Travailleurs qualifiés du Québec (PRTQ)",
          desc: "Pour ceux qui visent le Québec. Aucune offre d'emploi requise. Sélection basée sur le profil et le français.",
        },
        {
          name: "Programme des candidats des provinces (PCP)",
          desc: "Voies provinciales basées sur l'employeur ou les compétences. Nous identifions votre meilleur match.",
        },
        {
          name: "Permis d'études vers résidence permanente",
          desc: "Étudier au Canada puis transitionner vers la RP. La feuille de route en trois étapes la plus fiable.",
        },
        {
          name: "Parrainage familial",
          desc: "Pour ceux dont un proche est citoyen canadien ou résident permanent. Conjoint, parents, enfants.",
        },
        {
          name: "Visa Startup",
          desc: "Pour les entrepreneurs avec une idée d'affaires qualifiante. Investisseurs canadiens, lettre de soutien, RP en bout de course.",
        },
      ],
    },
    how: {
      eyebrow: "Le processus",
      headline: "5 étapes. Un nouveau départ.",
      steps: [
        {
          label: "Découverte",
          title: "Évaluation personnalisée",
          desc: "Un entretien de 30 minutes pour comprendre votre profil, vos objectifs et la voie d'immigration la plus adaptée.",
        },
        {
          label: "Planification",
          title: "Stratégie personnalisée",
          desc: "Nous concevons une feuille de route sur mesure — programme, calendrier, documents requis, coûts.",
        },
        {
          label: "Préparation",
          title: "Préparation du dossier",
          desc: "Traductions assermentées, équivalences de diplômes, lettres, formulaires. Chaque pièce vérifiée trois fois.",
        },
        {
          label: "Soumission",
          title: "Soumission & suivi",
          desc: "Dépôt officiel à IRCC. Suivi continu, réponses aux demandes complémentaires, mises à jour régulières.",
        },
        {
          label: "Installation",
          title: "Arrivée & installation",
          desc: "Accueil à l'aéroport, ouverture de compte, NAS, école des enfants. Vous n'êtes jamais seul à l'atterrissage.",
        },
      ],
    },
    why: {
      eyebrow: "Pourquoi Marocanada",
      headline: "L'autorité d'une ambassade. La chaleur d'une famille.",
      columns: [
        {
          title: "Experts agréés",
          desc: "Consultants réglementés en immigration canadienne (RCIC). Sécurité juridique totale.",
        },
        {
          title: "Bilingue dès la première minute",
          desc: "Français darija, anglais Canada. Aucune nuance perdue dans la traduction.",
        },
        {
          title: "Accompagnement de bout en bout",
          desc: "De la première question à votre premier hiver canadien. Présents.",
        },
      ],
    },
    testimonials: {
      eyebrow: "Témoignages",
      headline: "Ils ont fait le voyage.",
      list: [
        {
          quote:
            "Mon dossier d'Entrée Express avait été refusé deux fois avant Marocanada. En quatre mois, ils l'ont reconstruit, optimisé mon score CRS, et j'ai reçu mon ITA. Je suis arrivé à Montréal en janvier — ma femme et mes enfants m'ont rejoint en mars.",
          name: "Karim B.",
          city: "Casablanca → Montréal",
          pathway: "Entrée Express Francophone · 2024",
        },
        {
          quote:
            "J'ai postulé au PRTQ avec leur accompagnement. Préparation du dossier, lettre d'intention, équivalence de diplôme — chaque pièce vérifiée trois fois. Sept mois plus tard, j'enseignais à l'UQAM. Précision absolue.",
          name: "Sanae L.",
          city: "Rabat → Québec",
          pathway: "Programme des travailleurs qualifiés du Québec · 2023",
        },
        {
          quote:
            "Je voulais ouvrir mon restaurant à Calgary via le Visa Startup. Personne ne croyait que c'était possible depuis Marrakech. Marocanada a trouvé l'incubateur, monté le dossier, négocié la lettre de soutien. Aujourd'hui mon adresse est sur Stephen Avenue.",
          name: "Anas M.",
          city: "Marrakech → Calgary",
          pathway: "Visa Startup · 2023",
        },
      ],
    },
    map: {
      eyebrow: "Le voyage",
      headline: "De Casablanca à Montréal.",
      copy: "Nous vous accompagnons à chaque étape — de votre première question jusqu'à votre premier jour au Canada.",
      origin: "Casablanca",
      originLabel: "Origine",
      destination: "Montréal",
      destinationLabel: "Destination",
      distance: "≈ 5 600 km · 7 h 30 de vol direct",
    },
    cta: {
      eyebrow: "Consultation personnalisée",
      headline: "Consultation personnalisée.",
      sub: "Analyse complète de votre profil, programmes d'immigration adaptés et prochaines étapes concrètes. En français ou en anglais — nous répondons sous 24 heures.",
      response: "Nous répondons sous 24 heures — en français et en anglais.",
      whatsapp: "WhatsApp · +1 778 809 7227",
      email: "contact@marocanada.org",
      or: "ou",
      evalIntro: "Découvrez en 2 minutes les programmes pour lesquels vous êtes éligible.",
      evalButton: "Évaluer mon profil →",
      durationLabel: "Durée",
      durationValue: "30 minutes",
      includesLabel: "Ce qui est inclus",
      includes: [
        "Analyse complète de votre profil",
        "Programmes d'immigration qui vous correspondent",
        "Prochaines étapes concrètes et calendrier",
      ],
      buttonLabel: "Réserver ma consultation",
    },
    footer: {
      tagline: "Conseillers en immigration agréés. Casablanca · Montréal.",
      links: "Liens",
      contact: "Contact",
      faq: "FAQ",
      about: "Qui sommes-nous",
      legal: "© 2026 Marocanada — Licensed Immigration Consultants",
      privacy: "Confidentialité",
      terms: "Conditions",
    },
    about: {
      eyebrow: "À propos",
      headline: "Qui sommes-nous",
      back: "← Retour à l'accueil",
      cta: "Réserver ma consultation",
      sections: [
        {
          title: "Notre histoire",
          body: "Marocanada est née d'une expérience vécue de l'intérieur. Comme des milliers de Marocains francophones, nous avons traversé ce parcours — les questions sans réponses, les documents à rassembler, les délais à gérer, l'incertitude. Nous savons ce que ça fait de rêver du Canada tout en naviguant seul dans un système complexe. C'est pour ça que Marocanada existe. Pour que vous n'ayez pas à traverser ça seul. Installés au Canada depuis un moment, nous combinons l'expérience personnelle de l'immigration récente et une expertise concrète du processus canadien — de l'évaluation du profil CRS jusqu'à la confirmation de résidence permanente.",
        },
        {
          title: "Notre équipe",
          body: "Nous sommes une équipe complémentaire : chacun apporte son expertise — conseil en immigration, accompagnement administratif, relation client — pour vous offrir un suivi complet, humain et rigoureux.",
        },
        {
          title: "Notre engagement",
          body: "Pas de promesses garanties — personne ne peut garantir une décision d'IRCC. Mais nous vous promettons un accompagnement honnête, personnalisé, et présent à chaque étape.",
        },
      ],
    },
    faq: {
      eyebrow: "Foire aux questions",
      headline: "Entrée Express Francophone — vos questions, les vraies réponses.",
      back: "← Retour à l'accueil",
      cta: {
        title: "Une question qui n'est pas dans la liste ?",
        sub: "Réservez une consultation personnalisée — nous y répondrons directement.",
        button: "Réserver ma consultation",
      },
      items: [
        {
          q: "Qu'est-ce que l'Entrée Express Francophone et qui peut postuler ?",
          a: "L'Entrée Express Francophone (catégorie « compétence en français ») est une voie accélérée d'Entrée Express ouverte aux candidats qui démontrent un niveau de français NCLC 7 ou plus à l'oral, à l'écrit, en lecture et en écoute. Les Marocains francophones — médecins, ingénieurs, enseignants, techniciens — y sont particulièrement bien placés. Il faut aussi répondre aux critères d'un des trois programmes économiques fédéraux (Travailleurs qualifiés, Métiers spécialisés ou Catégorie de l'expérience canadienne).",
        },
        {
          q: "Quel niveau de français est requis (TEF Canada ou TCF Canada) ?",
          a: "Vous devez atteindre au minimum NCLC 7 dans les quatre compétences pour bénéficier des tirages francophones. C'est l'équivalent du TEF Canada : compréhension écrite 207, compréhension orale 249, expression écrite 310, expression orale 310. Ou pour le TCF Canada : 5 dans les quatre compétences. Les résultats sont valables 2 ans. Beaucoup de Marocains francophones natifs atteignent NCLC 8 ou 9 sans préparation intensive — ce qui ouvre encore plus de points CRS.",
        },
        {
          q: "Combien de points CRS faut-il pour recevoir une invitation (ITA) ?",
          a: "Les tirages francophones se font à un seuil CRS nettement plus bas que les tirages généraux. En 2025, les seuils typiques pour les tirages francophones se situent entre 379 et 410 points, contre 525-540 pour les tirages généraux. Un candidat francophone natif obtient automatiquement 50 à 75 points bonus pour la compétence en français — c'est le levier principal qui rend cette voie réaliste pour les Marocains.",
        },
        {
          q: "Combien de temps prend le processus complet de l'EEF ?",
          a: "Compter en moyenne 8 à 14 mois entre votre première consultation et l'atterrissage au Canada. Détail : préparation du dossier (1-3 mois), création du profil Entrée Express et attente d'invitation (1-6 mois selon les tirages), demande de résidence permanente après ITA (4-6 mois de traitement IRCC pour les dossiers francophones — prioritaires), puis 1-3 mois pour organiser le déménagement. Un dossier bien préparé dès le départ est ce qui fait la plus grande différence sur la durée totale.",
        },
        {
          q: "Quels documents marocains faut-il préparer (équivalences, traductions) ?",
          a: "Les pièces clés : passeport valide, certificats de naissance et de mariage légalisés, diplômes et relevés de notes avec évaluation des diplômes étrangers (EDE) par un organisme désigné (WES, ICAS, IQAS), attestations de travail des employeurs marocains avec détail des tâches, résultats TEF/TCF Canada, certificat de police marocain (extrait du casier judiciaire, légalisé et apostillé), visite médicale auprès d'un médecin agréé IRCC. Toutes les pièces non françaises/anglaises doivent être traduites par un traducteur assermenté.",
        },
      ],
    },
    fallback: {
      eyebrow: "Vous préférez discuter d'abord ?",
      sub: "Écrivez-nous — nous répondons sous 24 h.",
      whatsapp: "WhatsApp",
      email: "E-mail",
    },
    form: {
      title: "Réservez votre consultation",
      subtitle: "Nous vous rappelons sous 24 heures.",
      fullName: "Nom complet",
      email: "Adresse e-mail",
      phone: "Numéro de téléphone",
      submit: "Réserver ma consultation",
      sending: "Envoi…",
      success: "Demande reçue. Notre équipe vous contacte sous 24h.",
      error: "Une erreur est survenue. Réessayez ou contactez-nous par WhatsApp.",
      cancel: "Annuler",
      whatsappLabel: "WhatsApp",
      emailLabel: "E-mail",
    },
    languageToggle: { fr: "FR", en: "EN" },
  },
  en: {
    nav: {
      processus: "Process",
      services: "Services",
      testimonials: "Testimonials",
      contact: "Contact",
      getStarted: "Get Started",
    },
    hero: {
      eyebrow: "Casablanca · Montreal",
      headlineGold: "Maro",
      headlineCream: "canada",
      tagline: "Your path. Our expertise.",
      cta: "Start my file",
      scroll: "Scroll",
    },
    trust: {
      a: "500+ clients accompanied",
      b: "Licensed consultants",
      c: "Morocco × Canada",
    },
    opportunity: {
      eyebrow: "The Opportunity",
      headlineBig:
        "Moroccan French speakers qualify for Canada's Francophone Express Entry at a significantly lower CRS threshold.",
      body: "Canada is fast-tracking French-speaking candidates outside Quebec. This policy reshapes the lives of thousands of Moroccan profiles every year — doctors, engineers, students, families. The moment is now.",
      stat1: "+25%",
      stat1Label: "more francophone admissions in 2025",
      stat2: "−85",
      stat2Label: "CRS points below general threshold",
    },
    services: {
      eyebrow: "What We Do",
      headline: "Six pathways to Canada.",
      cta: "Learn more",
      list: [
        {
          name: "Francophone Express Entry",
          desc: "Ideal for French-speaking Moroccans. Lower CRS threshold through dedicated francophone draws.",
        },
        {
          name: "Quebec Skilled Worker Program (QSWP)",
          desc: "For those targeting Quebec. No job offer required. Selection based on profile and French proficiency.",
        },
        {
          name: "Provincial Nominee Program (PNP)",
          desc: "Employer-driven or skills-based provincial pathways. We identify your best match.",
        },
        {
          name: "Study Permit to Permanent Residence",
          desc: "Study in Canada then transition to PR. The most reliable three-step roadmap.",
        },
        {
          name: "Family Sponsorship",
          desc: "For those with a Canadian citizen or PR sponsor. Spouse, parents, children.",
        },
        {
          name: "Startup Visa",
          desc: "For entrepreneurs with a qualifying business idea. Canadian investors, letter of support, PR at the finish line.",
        },
      ],
    },
    how: {
      eyebrow: "The Process",
      headline: "5 steps. A fresh start.",
      steps: [
        {
          label: "Discovery",
          title: "Initial Assessment",
          desc: "A 30-minute conversation to understand your profile, your goals, and the immigration pathway that fits you best.",
        },
        {
          label: "Planning",
          title: "Custom Strategy",
          desc: "We design a tailored roadmap — program, timeline, required documents, costs.",
        },
        {
          label: "Preparation",
          title: "File Preparation",
          desc: "Certified translations, diploma equivalencies, letters, forms. Every piece triple-checked.",
        },
        {
          label: "Submission",
          title: "Submission & Tracking",
          desc: "Official IRCC submission. Continuous follow-up, replies to additional requests, regular updates.",
        },
        {
          label: "Settlement",
          title: "Arrival & Settlement",
          desc: "Airport welcome, bank account, SIN, kids' school. You are never alone on landing day.",
        },
      ],
    },
    why: {
      eyebrow: "Why Marocanada",
      headline: "The authority of an embassy. The warmth of a family.",
      columns: [
        {
          title: "Licensed Experts",
          desc: "Regulated Canadian Immigration Consultants (RCIC). Complete legal safety.",
        },
        {
          title: "Bilingual From Minute One",
          desc: "French darija, Canadian English. No nuance lost in translation.",
        },
        {
          title: "End-to-End Guidance",
          desc: "From your first question to your first Canadian winter. Present.",
        },
      ],
    },
    testimonials: {
      eyebrow: "Stories",
      headline: "They made the journey.",
      list: [
        {
          quote:
            "My Express Entry file had been refused twice before Marocanada. In four months, they rebuilt it, optimized my CRS score, and I received my ITA. I landed in Montreal in January — my wife and kids joined me in March.",
          name: "Karim B.",
          city: "Casablanca → Montreal",
          pathway: "Francophone Express Entry · 2024",
        },
        {
          quote:
            "I applied to the QSWP with their support. File preparation, letter of intent, diploma equivalency — every piece triple-checked. Seven months later I was teaching at UQAM. Absolute precision.",
          name: "Sanae L.",
          city: "Rabat → Quebec City",
          pathway: "Quebec Skilled Worker Program · 2023",
        },
        {
          quote:
            "I wanted to open my restaurant in Calgary through the Startup Visa. Nobody believed it was possible from Marrakech. Marocanada found the incubator, built the file, negotiated the letter of support. Today my address is on Stephen Avenue.",
          name: "Anas M.",
          city: "Marrakech → Calgary",
          pathway: "Startup Visa · 2023",
        },
      ],
    },
    map: {
      eyebrow: "The Journey",
      headline: "From Casablanca to Montreal.",
      copy: "We guide you every step of the way — from your first question to your first day in Canada.",
      origin: "Casablanca",
      originLabel: "Origin",
      destination: "Montreal",
      destinationLabel: "Destination",
      distance: "≈ 5,600 km · 7h 30 direct flight",
    },
    cta: {
      eyebrow: "Personalized Consultation",
      headline: "Personalized consultation.",
      sub: "Full profile analysis, matching immigration programs and concrete next steps. In French or English — we respond within 24 hours.",
      response: "We respond within 24 hours — in French and English.",
      whatsapp: "WhatsApp · +1 778 809 7227",
      email: "contact@marocanada.org",
      or: "or",
      evalIntro: "Find out in 2 minutes which programs you're eligible for.",
      evalButton: "Assess my profile →",
      durationLabel: "Duration",
      durationValue: "30 minutes",
      includesLabel: "What's included",
      includes: [
        "Full analysis of your profile",
        "Immigration programs that fit you",
        "Concrete next steps and timeline",
      ],
      buttonLabel: "Book my consultation",
    },
    footer: {
      tagline: "Licensed Immigration Consultants. Casablanca · Montreal.",
      links: "Links",
      contact: "Contact",
      faq: "FAQ",
      about: "Who We Are",
      legal: "© 2026 Marocanada — Licensed Immigration Consultants",
      privacy: "Privacy",
      terms: "Terms",
    },
    about: {
      eyebrow: "About us",
      headline: "Who We Are",
      back: "← Back to home",
      cta: "Book my consultation",
      sections: [
        {
          title: "Our Story",
          body: "Marocanada was born from a lived experience. Like thousands of French-speaking Moroccans, we went through this journey ourselves — the unanswered questions, the documents to gather, the deadlines to manage, the uncertainty. We know what it feels like to dream of Canada while navigating a complex system alone. That's why Marocanada exists. So you don't have to go through it alone. Having been in Canada for some time now, we combine first-hand experience of the immigration process with concrete expertise — from CRS profile assessment to permanent residence confirmation.",
        },
        {
          title: "Our Team",
          body: "We are a complementary team: each member brings their expertise — immigration advisory, administrative support, client relations — to provide you with complete, human, and rigorous support.",
        },
        {
          title: "Our Commitment",
          body: "No guaranteed promises — no one can guarantee an IRCC decision. But we promise honest, personalized guidance, present at every step of your journey.",
        },
      ],
    },
    faq: {
      eyebrow: "Frequently Asked Questions",
      headline: "Francophone Express Entry — straight answers to real questions.",
      back: "← Back to home",
      cta: {
        title: "A question that's not in the list?",
        sub: "Book a personalized consultation — we'll answer it directly.",
        button: "Book my consultation",
      },
      items: [
        {
          q: "What is Francophone Express Entry and who can apply?",
          a: "Francophone Express Entry is a fast-tracked stream within Canada's Express Entry system, reserved for candidates who demonstrate strong French ability (CLB 7 or higher in all four skills: speaking, listening, reading, writing). French-speaking Moroccans — doctors, engineers, teachers, technicians — are particularly well-positioned. You must also meet the criteria of one of the three federal economic programs (Federal Skilled Worker, Federal Skilled Trades, or Canadian Experience Class).",
        },
        {
          q: "What level of French is required (TEF Canada or TCF Canada)?",
          a: "You need a minimum of CLB 7 in all four French skills to benefit from francophone draws. That's equivalent to TEF Canada: reading 207, listening 249, writing 310, speaking 310 — or TCF Canada: level 5 in all four skills. Results are valid for 2 years. Many native French-speaking Moroccans reach CLB 8 or 9 without intensive preparation — which unlocks even more CRS points.",
        },
        {
          q: "How many CRS points do I need to receive an Invitation to Apply (ITA)?",
          a: "Francophone draws happen at significantly lower CRS thresholds than general draws. In 2025, typical francophone draw thresholds ranged between 379 and 410 points, versus 525–540 for general draws. A native French speaker automatically gets 50 to 75 bonus CRS points for French ability — that's the main lever that makes this pathway realistic for Moroccans.",
        },
        {
          q: "How long does the full Francophone Express Entry process take?",
          a: "Expect 8 to 14 months on average between your first consultation and landing in Canada. Breakdown: file preparation (1-3 months), Express Entry profile creation and wait for invitation (1-6 months depending on draws), permanent residence application after ITA (4-6 months IRCC processing for francophone files — prioritized), then 1-3 months to organize the move. A file that's well-prepared from day one is what makes the biggest difference on total duration.",
        },
        {
          q: "Which Moroccan documents do I need to prepare (equivalencies, translations)?",
          a: "Key pieces: valid passport, legalized birth and marriage certificates, diplomas and transcripts with Educational Credential Assessment (ECA) from a designated organization (WES, ICAS, IQAS, allow 6-12 weeks), employment letters from Moroccan employers with detailed duties, TEF/TCF Canada results, Moroccan police certificate (legalized and apostilled), medical exam by an IRCC-approved panel physician. All non-French/English documents must be translated by a sworn translator.",
        },
      ],
    },
    fallback: {
      eyebrow: "Prefer to talk first?",
      sub: "Message us — we respond within 24 hours.",
      whatsapp: "WhatsApp",
      email: "Email",
    },
    form: {
      title: "Book your consultation",
      subtitle: "We'll get back to you within 24 hours.",
      fullName: "Full name",
      email: "Email address",
      phone: "Phone number",
      submit: "Book my consultation",
      sending: "Sending…",
      success: "Request received. Our team will reach out within 24h.",
      error: "Something went wrong. Try again or reach us on WhatsApp.",
      cancel: "Cancel",
      whatsappLabel: "WhatsApp",
      emailLabel: "Email",
    },
    languageToggle: { fr: "FR", en: "EN" },
  },
};

export const WHATSAPP_NUMBER = "17788097227";
export const WHATSAPP_MESSAGE =
  "Bonjour, je souhaite en savoir plus sur l'immigration au Canada.";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;
export const CONTACT_EMAIL = "contact@marocanada.org";
